module.exports = __webpack_public_path__ + "static/toggl-track-main-e3405a87a61f4a887239ba3f28b6df42.jpg";